export const getStyle = (varName = '') =>
    varName.includes('--')
        ? getComputedStyle(document.documentElement).getPropertyValue(varName)
        : varName;
